var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.comSubTypeList[_vm.comSubType],{ref:"charts",tag:"component",attrs:{"widgetId":_vm.widgetId,"refreshPeriod":_vm.refreshPeriod}})}
var staticRenderFns = []

export { render, staticRenderFns }